import React from 'react';
import { Grid, Container } from '@mui/material';

// components
import Page from '../components/Page';
import BatchSummary from '../components/_dashboard/batch';

const BatchOverview = () => {
  return (
    <Page title='Dashboard | Belong'>
      <Container maxWidth='xl'>
        <Grid item xs={12} sm={12} md={12}>
          <BatchSummary />
        </Grid>
      </Container>
    </Page>
  );
};

export default BatchOverview;
